<script context='module'>
  import { getContext, setContext } from 'svelte';
  import { writable } from 'svelte/store';

  const CURRENT_ROUTE = Symbol('SidebarContext/currentRoute');
  const OPEN = Symbol('SidebarContext/open');

  export const useSidebarCurrentRoute = () => getContext(CURRENT_ROUTE);
  export const useSidebarOpen = () => getContext(OPEN);
</script>

<script>
  export let currentRoute;
  export let open;

  const currentRoute$ = writable(currentRoute);
  $: $currentRoute$ = currentRoute;

  const open$ = writable(open);
  $: $open$ = open;

  setContext(CURRENT_ROUTE, currentRoute$);
  setContext(OPEN, open$);
</script>

<slot />
